<!-- TODO THIS IS FOR TESTING PURPOSES ONLY AND WILL BE REMOVED AFTER THE QA PROCESS IS COMPLETED -->

<div class="min-h-screen px-4 py-8">
  <!-- Header -->
  <header class="max-w-[1400px] mx-auto mb-12">
    <div class="flex justify-between items-center flex-wrap gap-6">
      <div>
        <h1
          class="text-4xl font-bold bg-linear-to-r from-blue-500 to-violet-500 bg-clip-text text-transparent mb-2"
        >
          Analytics Charts Library
        </h1>
        <p class="text-lg text-slate-400 m-0">
          Reusable Angular chart components powered by Apache ECharts
        </p>
      </div>
    </div>
  </header>

  <!-- Chart Grid -->
  <div class="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
    <!-- Advanced Charts Section -->
    <section class=" mt-8">
      <h2 class="text-3xl font-bold text-slate-100 mb-2">Advanced Analytics Charts</h2>
      <p class="text-base text-slate-400 m-0">
        Complex visualizations including boxplots, mixed series, and time series
      </p>
    </section>

    <!-- Risk Distribution (Boxplot with Scatter) -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15 w-full"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Boxplot with Scatter Overlay</h3>
          <p class="text-sm text-slate-400 m-0">
            Risk score distribution comparing employee performance against peer groups
          </p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-violet-500/20 text-violet-300 border border-violet-500/30 whitespace-nowrap"
        >
          Advanced
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (riskDistributionConfig) {
          <app-generic-chart [config]="riskDistributionConfig" [loading]="loadingRiskDistribution" />
        } 
        @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          BoxplotChartConfig
        </code>
      </div>
    </div>

    <!-- Performance Distribution (Mixed Bar + Line) -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Mixed Chart (Bar + Line)</h3>
          <p class="text-sm text-slate-400 m-0">
            Performance score distribution with employee and team average markers
          </p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-violet-500/20 text-violet-300 border border-violet-500/30 whitespace-nowrap"
        >
          Advanced
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (performanceDistributionConfig) {
        <app-generic-chart
          [config]="performanceDistributionConfig"
          [loading]="loadingPerformanceDistribution"
        />
        } @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          MixedChartConfig
        </code>
      </div>
    </div>

    <!-- Risk Trends (Time Series) -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Multi-Line Time Series</h3>
          <p class="text-sm text-slate-400 m-0">
            Risk trends over 12 months across multiple categories
          </p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-blue-500/20 text-blue-300 border border-blue-500/30 whitespace-nowrap"
        >
          Time Series
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (riskTrendsConfig) {
        <app-generic-chart [config]="riskTrendsConfig" [loading]="loadingRiskTrends" />
        } @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          TimeSeriesChartConfig
        </code>
      </div>
    </div>

    <!-- Standard Charts Section -->
    <section class="col-span-full mt-12">
      <h2 class="text-3xl font-bold text-slate-100 mb-2">Standard Charts</h2>
      <p class="text-base text-slate-400 m-0">Common chart types for everyday analytics needs</p>
    </section>

    <!-- Line Chart -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Line Chart</h3>
          <p class="text-sm text-slate-400 m-0">Monthly revenue trends with area fill</p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 whitespace-nowrap"
        >
          Standard
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (lineChartConfig) {
        <app-generic-chart [config]="lineChartConfig" [loading]="loadingLineChart" />
        } @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          LineChartConfig
        </code>
      </div>
    </div>

    <!-- Bar Chart -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Bar Chart</h3>
          <p class="text-sm text-slate-400 m-0">Department performance comparison</p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 whitespace-nowrap"
        >
          Standard
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (barChartConfig) {
        <app-generic-chart [config]="barChartConfig" [loading]="loadingBarChart" />
        } @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          BarChartConfig
        </code>
      </div>
    </div>

    <!-- Pie Chart -->
    <div
      class="col-span-full bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden transition-all hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/15"
    >
      <div class="flex justify-between items-start gap-4 p-6 border-b border-slate-700/50">
        <div>
          <h3 class="text-xl font-semibold text-slate-100 mb-2">Pie Chart</h3>
          <p class="text-sm text-slate-400 m-0">Market share distribution by product</p>
        </div>
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 whitespace-nowrap"
        >
          Standard
        </span>
      </div>
      <div class="p-6 min-h-[450px] relative">
        @if (pieChartConfig) {
        <app-generic-chart [config]="pieChartConfig" [loading]="loadingPieChart" />
        } @else {
        <div class="flex items-center justify-center h-[400px] text-slate-500 text-sm">
          Loading chart configuration...
        </div>
        }
      </div>
      <div class="flex items-center gap-2 px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
        <span class="text-sm text-slate-400">Chart Type:</span>
        <code
          class="px-2 py-1 bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded text-xs font-mono"
        >
          PieChartConfig
        </code>
      </div>
    </div>
  </div>

</div>
